import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { CreateUserMembershipDto, UserMembershipDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_MEMBERSHIPS_QUERY_KEY } from './useGetUserMemberships';

export const useCreateUserMembership = (userId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['createUserMembership', userId],
        mutationFn: async (body: CreateUserMembershipDto) => {
            const response = await apiClient.fetchApi<UserMembershipDto, CreateUserMembershipDto>({ method: 'POST', endpoint: `users/${userId}/memberships`, body });
            return response
        },
        onSuccess: (data: UserMembershipDto) => {
            queryClient.setQueryData<UserMembershipDto[]>(GET_USER_MEMBERSHIPS_QUERY_KEY(userId), (previousData) => {
                return [...(previousData || []), data];
            });
        }
    });
};